import React from "react";
import { Column, DataGrid } from "devextreme-react/data-grid";
import { AddressTypes, useAddress } from "customer/settings/address/address.service";
import { localize } from "shared/helpers/utils";
import ActionsPanelComponent from "shared/component/dxf-grid/actions-panel.component";

interface AddressGridProps {
  addressType: AddressTypes;
  gridRef?: React.RefObject<DataGrid>;
}

function AddressGrid({ addressType, gridRef }: AddressGridProps) {
  const { addressSource, deleteAddress } = useAddress(addressType);
  const locale = (cell: any) => localize(cell.value);
  return (
    <div className="dataTable">
      <DataGrid
        height={500}
        showBorders
        dataSource={addressSource}
        paging={{ enabled: true, pageSize: 10 }}
        pager={{ visible: true }}
        remoteOperations={{ paging: true }}
        ref={gridRef}
        columnAutoWidth
      >
        <Column dataField="No" cellRender={(c) => c.rowIndex + 1} />
        <Column dataField="addressName" cellRender={locale} />
        <Column dataField="cityName" cellRender={locale} />
        <Column dataField="contactPerson" cellRender={locale} />
        <Column dataField="phone" />
        <Column dataField="neighborhoodName" cellRender={locale} />
        <Column dataField="streetName" cellRender={locale} />
        <Column dataField="buildingNumber" />
        <Column dataField="location" />
        <Column
          width="70"
          dataField='.'
          alignment='center'
          cellRender={(c) => (
            <ActionsPanelComponent
              actions={[{ label: "delete", action: () => deleteAddress(c.data?.id) }]}
            />
          )}
        />
      </DataGrid>
    </div>
  );
}

export default AddressGrid;
